export const listVitalsWatchFindings = (vitals) => {
  if (!vitals) return [];

  const toNumber = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const formatReading = (value) => {
    if (!Number.isFinite(value)) return String(value);
    return Number.isInteger(value) ? String(value) : String(Number(value.toFixed(1)));
  };

  const temperature = toNumber(vitals.temperature);
  const pulse = toNumber(vitals.pulse);
  const sbp = toNumber(vitals.blood_pressure_systolic);
  const spo2 = toNumber(vitals.spo2);
  const respiration = toNumber(vitals.respiration_rate);
  const findings = [];

  if (temperature !== null && temperature >= 38) {
    findings.push({ key: 'fever', label: `Fever · ${formatReading(temperature)}°C`, priority: 1 });
  } else if (temperature !== null && temperature < 36) {
    findings.push({ key: 'low_temp', label: `Low temperature · ${formatReading(temperature)}°C`, priority: 1 });
  }

  if (respiration !== null && respiration >= 21) {
    findings.push({ key: 'fast_breathing', label: `Fast breathing · ${respiration}`, priority: 2 });
  }

  if (spo2 !== null && spo2 <= 93) {
    findings.push({ key: 'low_oxygen', label: `Low oxygen · ${formatReading(spo2)}%`, priority: 3 });
  }

  if (sbp !== null && sbp !== 0 && sbp <= 100) {
    findings.push({ key: 'low_bp', label: `Low blood pressure · ${formatReading(sbp)}`, priority: 4 });
  } else if (sbp !== null && sbp >= 150) {
    findings.push({ key: 'high_bp', label: `High blood pressure · ${formatReading(sbp)}`, priority: 4 });
  }

  if (pulse !== null && pulse >= 110) {
    findings.push({ key: 'fast_pulse', label: `Fast pulse · ${formatReading(pulse)}`, priority: 5 });
  } else if (pulse !== null && pulse <= 60) {
    findings.push({ key: 'slow_pulse', label: `Slow pulse · ${formatReading(pulse)}`, priority: 5 });
  }

  return findings.sort((a, b) => a.priority - b.priority);
};
